import cx from 'clsx';
import type { ComponentType, HTMLProps, ReactElement, ReactNode, SVGProps } from 'react';
import styles from './highlight.module.css';

export interface HighlightProps extends HTMLProps<HTMLSpanElement> {
  text: ReactNode;
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  className?: string;
  variant?: 'default' | 'glass';
}

export function BadgeHighlight({
  text,
  icon: Icon,
  className,
  variant = 'default',
  ...props
}: HighlightProps): ReactElement {
  return (
    <span
      className={cx(styles.highlight, 'caption', className, variant === 'glass' && styles.glass)}
      data-test-badge-highlight=""
      {...props}
    >
      {Icon ? (
        <span className={styles.icon}>
          <Icon aria-hidden="true" height={16} width={16} />
        </span>
      ) : null}
      {text}
    </span>
  );
}
